import { render, staticRenderFns } from "./CloneButton.vue?vue&type=template&id=50447bf1"
import script from "./CloneButton.vue?vue&type=script&lang=js"
export * from "./CloneButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports